import { Outlet } from 'react-router-dom'

import { ComposerDialog } from '@/features/posts'

import { BottomNav } from './BottomNav'
import { RightAside } from './RightAside'
import { Sidebar } from './Sidebar'

/**
 * 三栏布局：左导航 275px / 中列 600px / 右栏 350px。
 * < 1280 左栏折叠为图标；< 1024 隐藏右栏；< 640 左栏变底部 tab 栏。
 */
export function AppLayout() {
  return (
    <div className="mx-auto flex min-h-screen max-w-[1265px] justify-center">
      <div className="hidden w-[88px] shrink-0 sm:block xl:w-[275px]">
        <Sidebar />
      </div>

      {/* 左右的分隔线只在三栏时才有意义；手机上中列就是整屏，两侧再描一道边只剩突兀 */}
      <main className="w-full min-w-0 max-w-[600px] border-line pb-[calc(4rem+env(safe-area-inset-bottom))] sm:border-x sm:pb-0">
        <Outlet />
      </main>

      <div className="hidden w-[350px] shrink-0 lg:block">
        <RightAside />
      </div>

      <BottomNav />
      <ComposerDialog />
    </div>
  )
}
